// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"bb912465","321":"485d55dc","745":"177b6bee","787":"cda612ba","910":"23250c1d","922":"afe34d4e"}[chunkId] + ".chunk.js";
};